import { useAuth } from "@/context/AuthContext";

/**
 * Single source of truth for app branding (name + subtitle + logo).
 * Sourced from /api/config which is seeded by the APP_NAME / APP_LOGO_URL /
 * APP_SUBTITLE env vars on the host. Defaults preserve the original brand
 * ("OfferAlchemy by The Studio · The Rahul Gangurde.") so unset env vars =
 * no visual change.
 */
export function useBrand() {
  const { appConfig } = useAuth();
  const name = (appConfig?.app_name || "OfferAlchemy").trim();
  const logoUrl =
    (appConfig?.app_logo_url || "").trim() ||
    "https://therahulgangurde.com/assets/logo-email.svg";
  const subtitle = (appConfig?.app_subtitle || "").trim();
  const initial = name.charAt(0).toUpperCase() || "O";
  return { name, logoUrl, subtitle, initial };
}
